import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authenticatedFetch } from "../../services/authenticatedFetch";
import LoadingMark from "./LoadingMark";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const UserAuthenticationGuard = ({ children, redirectPath = "/login" }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuthentication = async () => {
      setIsLoading(true);

      try {
        // Do not hard-redirect here: let <Navigate> handle unauthenticated users.
        // A hard redirect after a failed cookie send (common on iOS) feels like a login loop.
        const response = await authenticatedFetch(`${API_BASE_URL}/me`, {
          method: "GET",
          redirectOnAuthFailure: false,
        });

        if (response.ok) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Erro ao verificar autenticação:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, []);

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-background">
        <LoadingMark
          size="md"
          message="Carregando.."
          messageClassName="font-medium font-body"
        />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={redirectPath}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default UserAuthenticationGuard;
